import React from 'react'
import { Route } from 'react-router-dom'
import ActivateAccount from './ActivateAccount'

import { activateAccountRoot } from "../../../constants/routePaths"

const ActivateAccountRoute = [
  <Route
    key="ActivateAccount"
    exact path={activateAccountRoot}
    component={ActivateAccount}
  />,
];

export default ActivateAccountRoute